import { createFeatureSelector } from '@ngrx/store';

export const orderTypesState = createFeatureSelector<OLO.State, OLO.State.OrderTypes>('orderTypes');
